<template>
	<div style="position: relative;">
		<v-container fluid class="mt-3">
			<v-row>
				<v-col cols="12" class="d-flex justify-center">
					<v-img :src="content.mainImg.src" contain :max-height="`${content.maxHeight}px`" />
				</v-col>
			</v-row>
			<v-sheet color="primary lighten-3" class="py-5">
				<v-container class="mb-5">
					<div>
						<h3 class="text-center mb-6 fs-h3 white--text">شرکای تجاری ما</h3>
					</div>
					<v-row>
						<v-col cols="12" sm="4" v-for="(item, idx) in content.slides" :key="idx">
							<v-card class="pa-5 rounded-tl-xl rounded-br-xl mx-6" flat color="white">
								<div style="height:170px;">
									<div class="d-flex justify-center">
										<v-avatar class="" color="white" size="75" x-large>
											<img :src="`${item.img.src || '/NafisTheme/diamond.jpg'}`" :alt="`${item.name}-شرکای تجاری ما`">
										</v-avatar>
									</div>
									<div class="text-center mt-5">
										{{ item.name }}
									</div>
								</div>
								<div class="text-center">
									<a target="_blank" :href="item.url">
										<v-btn class="rounded-tl-xl rounded-br-xl gradient-background" dark elevation="0" style="min-width: 100px;">
											وب سایت
										</v-btn>
									</a>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-sheet>
		</v-container>

		<div v-if="editable" style="position: absolute;top: 0; left: 0;">
			<v-btn small color="secondary" outlined @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="650px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تنظیمات شرکای تجاری</span></div>
					<v-spacer />
					<v-btn @click="settingsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container v-if="settingsDialog">
						<v-row>
							<v-col cols="12" md="4">
								<div>تصویر اصلی</div>
								<ImageUploader :ref="'mainImageUploader'" v-model="settings.mainImg.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(settings.mainImg.src)" @delete="() => { settings.mainImg.src = '' }" />
							</v-col>
							<v-col cols="8">
								<v-text-field dense v-model="settings.maxHeight" type="number" label="حداکثر ارتفاع تصویر اصلی"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card color="#eee" elevation="0" v-for="(slide, idx) in settings.slides" :key="idx" class="mb-3">
									<v-card-title class="d-flex justify-space-between">
										<h3>شریک تجاری {{ idx + 1 }}</h3>
										<v-btn color="red" text small @click="removeSlide(idx)">حذف</v-btn>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text>
										<v-row>
											<v-col cols="12" md="4">
												<ImageUploader :ref="'imageUploader' + idx" v-model="slide.img.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(slide.img.src)" @delete="() => { slide.img.src = '' }" />
											</v-col>
											<v-col cols="12" md="8">
												<div>
													<v-text-field dense v-model="slide.name" label="نام"></v-text-field>
												</div>
												<div>
													<v-text-field dense v-model="slide.url" class="left-input" label="آدرس سایت"></v-text-field>
												</div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
								<div class="px-3 text-center">
									<v-btn small color="secondary" @click="addSlide()">افزودن اسلاید</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="settingsDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" dark @click="submitEdit" :loading="submitEditLoading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { cloneDeep, isEmpty } from 'lodash'
	import { siteContentRootPath } from '@/util/enums'
	import { get } from 'vuex-pathify'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'


	export default {
		name: 'NafisCorporators',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean }
		},
		components: {
			ImageUploader
		},
		data: () => ({
			settings: {},
			localData: null,
			settingsDialog: false,
			submitEditLoading: false
		}),
		computed: {
			...get('siteConfig', [
				'customerCode'
			]),
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			}
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content)
				}
			}
			else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent()
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					maxHeight: 450,
					mainImg: { val: '', type: 'img', src: '/NafisTheme/tim.webp' },
					slides: [{
						name: '',
						url: '',
						img: { val: '', type: 'img', src: '/NafisTheme/diamond.jpg' }
					},
					{
						name: '',
						url: '',
						img: { val: '', type: 'img', src: '/NafisTheme/diamond.jpg' }
					},
					{
						name: '',
						url: '',
						img: { val: '', type: 'img', src: '/NafisTheme/diamond.jpg' }
					}]
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				this.processImages().then(res => {
					const data = cloneDeep(this.localData)
					data.content = JSON.stringify(this.settings)
					api.post(`admin/SiteContent/CreateUpdate`, data)
						.then(response => {
							this.localData.content = cloneDeep(this.settings)
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { })
				}).catch(err => { })
					.finally(f => {
						this.submitEditLoading = false
						this.settingsDialog = false
					})
			},
			removeSlide(idx) {
				this.settings.slides.splice(idx, 1)
			},
			addSlide() {
				this.settings.slides.push({
					name: '',
					url: '',
					img: { val: '', type: 'img', src: '' }
				})
			},
			processImages() {
				return new Promise(async (resolve, reject) => {
					const formData = new FormData()
					var fileUploader = this.$refs.mainImageUploader
					if (fileUploader && fileUploader.hasFile()) {
						formData.append(`File`, fileUploader.getFile())
						formData.append(`fileName`, this.settings.mainImg.val)
						await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
							.then(response => {
								this.settings.mainImg.val = response
								this.settings.mainImg.src = `${siteContentRootPath}${this.ccode}/${response}`
							})
							.catch(err => {
								toast.error(err.message)
								reject()
							})
							.finally(x => { })
					} else if (this.settings.mainImg.val && !this.settings.mainImg.src) {
						await api.post('admin/SiteContent/DeleteImage', { fileName: this.settings.mainImg.val })
							.catch(err => {
								toast.error(err.message)
								reject()
							})
					}
					for (let i = 0; i < this.settings.slides.length; i++) {
						let slide = this.settings.slides[i]
						const formData = new FormData()
						var fileUploader = Array.isArray(this.$refs['imageUploader' + i]) ? this.$refs['imageUploader' + i][0] : null
						if (fileUploader && fileUploader.hasFile()) {
							formData.append(`File`, fileUploader.getFile())
							formData.append(`fileName`, slide.img.val)
							await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
								.then(response => {
									slide.img.val = response
									slide.img.src = `${siteContentRootPath}${this.ccode}/${response}`
								})
								.catch(err => {
									toast.error(err.message)
									reject()
								})
								.finally(x => { })
						} else if (slide.img.val && !slide.img.src) {
							await api.post('admin/SiteContent/DeleteImage', { fileName: slide.img.val })
								.catch(err => {
									toast.error(err.message)
									reject()
								})
						}
					}
					resolve()
				})
			}
		},
	}
</script>

<style lang="scss"></style>